import {PaginaLogada} from "../../componentes";
import {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {exibirMensagemSucesso, HttpVerbo, xfetch} from "../../util";
import {UsuarioDto} from "../../tipos/dto/usuario-dto";
import CardPadrao from "../../componentes/card/card-padrao";
import {Grid, TagsInput, TextInput} from "@mantine/core";
import {Setor} from "../../tipos/setor";
import {COL_RESP_2, COL_RESP_4} from "../../config/constantes/constantes-mantine";
import {Role} from "../../tipos/role";
import {BotaoSalvar} from "../../componentes/botao/botao-mantine";
import {IconTag} from "@tabler/icons-react";
import Atividade from "../../componentes/atividade";
import SetorSelect from "../../componentes/form/setor-select/setorSelect";

export default function UsuarioEditar() {

  const parametros = useParams()
  const [isCarregando, setIsCarregando] = useState(false)
  const [usuario, setUsuario] = useState<UsuarioDto>(new UsuarioDto())
  const [setor, setSetor] = useState(-1)
  const [permissoesUsuario, setPermissoesUsuario] = useState<Role[]>([])
  const [permissoes, setPermissoes] = useState<string[]>([])
  const [atividades, setAtividades] = useState([])

  const fetchUsuario = async () => {
    setIsCarregando(true)
    const res =
      await xfetch('/usuario/'+parametros.id, {}, HttpVerbo.GET)
        .catch(() => {setIsCarregando(false)})
    const json = await res.json();
    setUsuario(json)
    setSetor(json.setor?.id)
    setPermissoesUsuario(json.permissoes)
    setIsCarregando(false)
  }

  const fetchAtividades = async () => {
    setIsCarregando(true)
    const res = await xfetch('/atividade/usuario/' + parametros.id, {}, HttpVerbo.GET).finally(() => setIsCarregando(false));
    const json = await res.json();
    setAtividades(json)
  }

  const fetchPermissoes = async () => {
    setIsCarregando(true)
    const res = await xfetch('/permissao', {}, HttpVerbo.GET).finally(() => setIsCarregando(false));
    const json = await res.json();
    setPermissoes(json)
    setIsCarregando(false)
  }

  function inicializacao() {
    fetchUsuario()
    fetchPermissoes()
    fetchAtividades()
  }

  function enviar() {
    const dados = {
      idUsuario: parametros.id,
      idSetor: setor,
      permissoes: permissoesUsuario.map(p => p.role)
    }
    xfetch('/usuario/'+ parametros.id, dados, HttpVerbo.PUT)
      .then(res => res.json())
      .then(json => {
        exibirMensagemSucesso("Usuario Alterado com Sucesso.")
        inicializacao()
      });
  }

    function setRoles(p: string[]) {
    const roles = p.map( s => new Role(s))
    setPermissoesUsuario(roles)
  }

  useEffect(() => {
    inicializacao();
  }, [])

  return (
    <PaginaLogada isCarregando={isCarregando} titulo="Editar Usuário" botaoVoltar={true}>
      <CardPadrao>
        <Grid>
          <Grid.Col span={COL_RESP_4}>
            <TextInput
              disabled
              label={"Nome"}
              value={usuario.nome}
            />
          </Grid.Col>
          <Grid.Col span={COL_RESP_4}>
            <TextInput
              disabled
              label={"E-mail"}
              value={usuario.email}
            />
          </Grid.Col>
          <Grid.Col span={COL_RESP_4}>
            <SetorSelect label={"Setor"} setorInicial={usuario.setor} setorId={setor} setSetorId={setSetor}  />
          </Grid.Col>
          <Grid.Col span={COL_RESP_4}>
            <TagsInput
              clearable
              label={"Permissões"}
              data={permissoes}
              leftSection={<IconTag/>}
              value={permissoesUsuario.map(p => p.role !== undefined ? p.role.toString() : "")}
              onChange={(e) => setRoles(e)}
              styles={{
                pill: {backgroundColor: '#FFD43B'}
              }}
              />
          </Grid.Col>
          <Grid.Col span={COL_RESP_2} style={{alignSelf: 'self-end'}}>
            <BotaoSalvar onClick={enviar} />
          </Grid.Col>
        </Grid>
      </CardPadrao>

      <Atividade dados={atividades} mt={30}/>
    </PaginaLogada>
  );
}